import { useCallback } from 'react';

interface MailToOptions {
  email?: string;
  subject?: string;
  body?: string;
  cc?: string | string[];
  bcc?: string | string[];
}

const useMailTo = (options: MailToOptions = {}) => {
  const { email = '', subject = '', body = '', cc = '', bcc = '' } = options;

  const formatRecipients = (recipients: string | string[]): string => {
    return Array.isArray(recipients)
      ? recipients.map(email => encodeURIComponent(email)).join(',')
      : encodeURIComponent(recipients);
  };

  const openMail = useCallback((): void => {
    let mailtoUrl = `mailto:${encodeURIComponent(email)}`;
    const params: string[] = [];

    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    if (cc) params.push(`cc=${formatRecipients(cc)}`);
    if (bcc) params.push(`bcc=${formatRecipients(bcc)}`);

    if (params.length > 0) {
      mailtoUrl += '?' + params.join('&');
    }

    window.location.href = mailtoUrl;
  }, [email, subject, body, cc, bcc]);

  return openMail;
};

export default useMailTo;
